module.exports = __webpack_public_path__ + "img/listed.1fad764.png";